import styled from '@emotion/styled';
import { ICustomTheme } from 'interfaces';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Link as MaterialUILink } from '@material-ui/core';

export const StyledReactRouterLink = styled(ReactRouterLink)<{
  theme: ICustomTheme;
  color?: string;
  fontWeight?: string | number;
  withUnderline?: boolean;
  isMobile?: boolean;
}>`
  color: ${({ color }) => color || 'black'};
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  text-decoration: ${({ withUnderline }) =>
    withUnderline ? 'underline' : 'none'};
  font-size: ${({ isMobile, theme }) =>
    `${
      isMobile
        ? theme.fontSizes.mobileBasicText
        : theme.fontSizes.desktopBasicText
    }px`};
`;

export const StyledMaterialUILink = styled(MaterialUILink)<{
  theme: ICustomTheme;
  fontWeight?: string | number;
  withUnderline?: boolean;
  isMobile?: boolean;
}>`
  display: inline;
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  text-decoration: ${({ withUnderline }) =>
    withUnderline ? 'underline' : 'none'};
  font-size: ${({ isMobile, theme }) =>
    `${
      isMobile
        ? theme.fontSizes.mobileBasicText
        : theme.fontSizes.desktopBasicText
    }px`};
`;
